<script setup lang="ts">
import { ref, watch } from 'vue'
import { useRouter } from 'vue-router'
import SearchResults from './SearchResults.vue'

const query = ref('')
const showResults = ref(false)
const router = useRouter()

// Sample data - replace with actual data from your application
const features = [
  { id: 1, name: 'Point of Sale', icon: '🏪', path: '/pos' },
  { id: 2, name: 'Inventory Management', icon: '📦', path: '/inventory' },
  { id: 3, name: 'Customer Management', icon: '👥', path: '/customers' },
  { id: 4, name: 'Sales Reports', icon: '📊', path: '/reports/sales' },
  { id: 5, name: 'Financial Reports', icon: '💰', path: '/reports/finance' }
]

const records = [
  { id: 1, name: 'Recent Sales', icon: '💵', type: 'Sales', path: '/sales' },
  { id: 2, name: 'Top Customers', icon: '⭐', type: 'Customer', path: '/customers' },
  { id: 3, name: 'Low Stock Items', icon: '⚠️', type: 'Inventory', path: '/inventory' }
]

const docs = [
  { id: 1, name: 'Getting Started', icon: '📚', path: '/docs/getting-started' },
  { id: 2, name: 'POS Guide', icon: '📖', path: '/docs/pos' },
  { id: 3, name: 'API Documentation', icon: '🔧', path: '/docs/api' }
]

const filteredFeatures = ref(features)
const filteredRecords = ref(records)
const filteredDocs = ref(docs)

watch(query, (newQuery) => {
  if (newQuery) {
    const searchTerm = newQuery.toLowerCase()
    filteredFeatures.value = features.filter(item => 
      item.name.toLowerCase().includes(searchTerm)
    )
    filteredRecords.value = records.filter(item => 
      item.name.toLowerCase().includes(searchTerm) || 
      item.type.toLowerCase().includes(searchTerm)
    )
    filteredDocs.value = docs.filter(item => 
      item.name.toLowerCase().includes(searchTerm)
    )
    showResults.value = true
  } else {
    showResults.value = false
  }
})

const handleSelect = (path: string) => {
  router.push(path)
  showResults.value = false
  query.value = ''
}

const handleClickOutside = () => {
  showResults.value = false
}
</script>

<template>
  <div class="relative" v-click-outside="handleClickOutside">
    <!-- Search Input -->
    <div class="relative">
      <span class="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400">🔍</span>
      <input
        v-model="query"
        type="search"
        placeholder="Search features, records, or documentation..."
        class="w-96 pl-10 pr-4 py-2 rounded-lg border border-gray-200 dark:border-gray-700 bg-white dark:bg-gray-800 text-gray-900 dark:text-white placeholder-gray-500 dark:placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-blue-500 dark:focus:ring-blue-400"
        @focus="showResults = true"
      />
    </div>

    <!-- Search Results -->
    <SearchResults
      v-if="showResults"
      :features="filteredFeatures"
      :records="filteredRecords"
      :docs="filteredDocs"
      @select="handleSelect"
    />
  </div>
</template>